var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 7.51247V8.00313C13.3327 9.15322 12.9603 10.2723 12.2717 11.1934C11.583 12.1146 10.6151 12.7885 9.51221 13.1145C8.40931 13.4406 7.23056 13.4015 6.15174 13.0029C5.07292 12.6043 4.15184 11.8677 3.52587 10.9029C2.8999 9.93808 2.60258 8.79677 2.67825 7.64917C2.75392 6.50157 3.19853 5.40917 3.94577 4.53491C4.69301 3.66064 5.70284 3.05134 6.82465 2.79788C7.94647 2.54442 9.12016 2.66038 10.1707 3.12847",
    stroke: "#287BBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 4L8.20515 9.33333L6.66669 7.73493",
    stroke: "#287BBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusComplete);
export default __webpack_public_path__ + "static/media/status-complete.1c1c43039485cd04ea2632d0d5b8c60b.svg";
export { ForwardRef as ReactComponent };